module.exports = __webpack_public_path__ + "img/w3_package_thin_black.410b6f32.png";